import React from 'react'

import { useNavigate } from 'react-router-dom';
// import { FaArrowUp } from "react-icons/fa6";

// ------------------swiper------------------
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import { FreeMode, Pagination } from 'swiper/modules';
import { SwiperCardData } from '../data/swiperCardData';


const SwiperCard = () => {
    const navigate = useNavigate();
    return (
        <div className='w-100 my-2'>
            <Swiper
                slidesPerView={'auto'}
                spaceBetween={20}
                freeMode={true}
                modules={[FreeMode, Pagination]}
                style={{ height: "auto", padding: "0 16px" }}
            >
                {SwiperCardData && SwiperCardData.map((card) => {
                    return (
                        <SwiperSlide className='product_card_wrapper' key={card.id}>
                            {/* <Card className="bgCard-card position-relative" sx={{ minHeight: '340px', width: 300 }}> */}
                            <div className="product-card pointer-event" onClick={() => navigate(`/product/${card.id}`)} style={{ cursor: 'pointer' }}>
                                <div class="badge">Hot</div>
                                <div class="product-tumb">
                                    <img className='img-fluid' src={card.cardImage} alt="" />
                                </div>
                                <div className="product-details">
                                    <span className="product-catagory">Collection</span>
                                    <h4><a href="#!" onClick={(e) => e.preventDefault()}>{card.title}</a></h4>
                                    <p className='text-truncate-2'>{card.textContent}</p>
                                    <div className="product-bottom-details">
                                        <div className="product-price"><small>$96.00</small>$230.99</div>
                                        <div className="product-links d-flex gap-2 justify-content-end">
                                            <a href="#!" onClick={(e) => e.preventDefault()}><i className="fa fa-heart"></i></a>
                                            <a href="#!" onClick={(e) => e.preventDefault()}><i className="fa fa-shopping-cart"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* </Card> */}
                        </SwiperSlide>
                    )
                })}
            </Swiper>
        </div>
    )
}

export default SwiperCard;